// @flow

import React from "react";
import type { Node } from "react";
import className from "classnames";
import { Button, View, Text } from "@components";
import Column from "./subcomponents/column";
import SubColumns from "./subcomponents/subcolumns";
import SubRows from "./subcomponents/subrows";
import type { ButtonType, Rows } from "./types";
import "./columns-container.style.scss";

export type Props = {
  className?: string,
  columnClassName?: string,
  title?: string,
  rows: Rows[],
  children?: Node,
};

export const ColumnsContainer = (props: Props) => (
  <View name="ColumnsContainer" gap={3} flex="1">
    {/* Container title and title buttons */}
    <Text type="h5" text={props.title || ""} />

    {/* Creating main rows */}
    {props.rows.map((row, index) => (
      <View name="ColumnsContainer-Row" gap={10} direction="row" key={`row-${index}`}>
        {row.columns.map((column, index) => (
          <View name="ColumnsContainer-Column" flex={1} key={`column-${index}`}>
            {!column.subRows && !column.subColumns && (
              <Column column={column} className={props.columnClassName} />
            )}
            {/* if has subColumns in a column */}
            {column.subColumns && !column.subRows && <SubColumns column={column} />}
            {/* if has multiple subRows in one column */}
            {column.subRows && <SubRows rows={column.subRows} />}
            {column.component}
          </View>
        ))}
      </View>
    ))}

    {props.children && <div className="px-3">{props.children}</div>}
  </View>
);

ColumnsContainer.defaultProps = {
  // centeredTitle: false,
  // titleColor: "black",
};

export default ColumnsContainer;
